import endpoints from "api/endpoints";

export default (
  { resultKey = "isFiatDeleted", fiatId } = { resultKey: "isFiatDeleted" }
) => ({
  url: endpoints.getActionFiatUrl(fiatId),
  transform: (response) => !response.error,
  transformResult: (response) => ({
    [resultKey]: !response.error,
  }),
  queryKey: endpoints.getActionFiatUrl(fiatId),
  meta: {
    authToken: true,
  },
  force: true,
  options: {
    headers: {
      Accept: "application/json",
    },
    method: "DELETE",
  },
  update: {},
  updateResult: {
    [resultKey]: (prevResult, result) => result,
  },
});
